import React, { useEffect, useState } from "react";
import { person, titleIcon, titleIcon2 } from "../../assets/images";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Comments = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const comments = useSelector((state) => state.comments.items);
  const [allProducts, setAllProducts] = useState([]);
  const [visibleCount, setVisibleCount] = useState(5);

  useEffect(() => {
    const getProducts = async () => {
      try {
        const res = await axios.get(
          `https://www.elzabeauty.az/elza/dashboard.php`
        );
        const data = res.data.data || [];

        // ❗️Sadece yorumu olan ürünleri filtrele
        const filtered = data.filter((product) =>
          comments?.some((comment) => comment.product_id == product.id)
        );
        setAllProducts(filtered);
      } catch (err) {
        console.error(err);
      }
    };
    getProducts();
  }, [comments]); // ❗️Yorumlar değiştiğinde yeniden filtrele

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 5);
  };

  const visibleProducts = allProducts.slice(0, visibleCount);

  return (
    <div className="pt-10 md:pt-20 max-w-containerSm md:max-w-container mx-auto">
      <div className="flex flex-col justify-center items-center">
        <div className="flex items-center">
          <img className="w-[50px] h-auto mr-2" src={titleIcon} alt="icon1" />
          <p className="text-[24px] md:text-[28px] font-semibold text-center md:text-left text-[#181D27]">
            {t("Müştərilərimiz Nə Deyir?")}
          </p>
          <img className="w-[50px] h-auto ml-2" src={titleIcon2} alt="icon2" />
        </div>
        <p className="mt-2 text-center tex-[12px] md:text-[16px]">
          {t(
            "Əsl istifadəçilərimizin fikirləri və nəticələri ilə tanış olun. Onların məmnuniyyəti bizim üçün ən böyük uğurdur!"
          )}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-8 mt-10">
        {visibleProducts.map((product) => {
          const productComments = comments?.filter(
            (c) => c.product_id == product.id
          );

          return (
            <div
              key={product.id}
              className="rounded-lg md:flex justify-between flex-wrap"
            >
              <div className="text-center mb-4 md:w-[320px]">
                <a href={`/${currentLanguage}/product-detail/${product.id}`}>
                  <img
                    src={`https://www.elzabeauty.az/elza/${product.image1}`}
                    alt={product.name}
                    className="w-full h-[200px] object-cover rounded-md mb-2"
                  />
                </a>
                <h3 className="font-semibold">{product.name}</h3>
              </div>

              <div className="md:w-[836px] bg-white rounded-lg relative">
                <Swiper
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={true}
                  modules={[Navigation]}
                >
                  {productComments.map((comment, index) => (
                    <SwiperSlide key={index}>
                      <div className="p-4 rounded md:h-[228px]">
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex gap-2 items-center">
                            <img
                              className="w-[38px] h-[38px]"
                              src={person}
                              alt="User Avatar"
                            />
                            <span className="font-medium">
                              {comment.username}
                            </span>
                          </div>
                          <span className="text-sm text-gray-500">
                            {comment.created_at}
                          </span>
                        </div>
                        <p className="text-gray-700">{comment.content}</p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          );
        })}
      </div>

      {/* Load More Button */}
      {visibleCount < allProducts.length && (
        <div className="flex justify-center mt-6">
          <button
            onClick={handleLoadMore}
            className="bg-[#181D27] text-white px-6 py-2 rounded-md hover:bg-[#303642] transition"
          >
            {t("Daha çox")}
          </button>
        </div>
      )}
    </div>
  );
};

export default Comments;
